
// This file is generated by the maven plugin com.axley.js-remodel.  Do not edit!!!

import { GenState } from './GenState';

export class GenEiaRegion {

    id: number;
    name: string;
    states: GenState[];

    constructor();
    constructor( jsonObj: any );
    constructor( genEiaRegion: GenEiaRegion);
    constructor( id: number );

    constructor( input?: GenEiaRegion|number ) {
        if ( typeof input === 'number') {
            this.id = input;
        }

        if ( input && typeof input !== 'number' ) {
            this.id = input.id; // int [number]
            this.name = input.name; // string [string]
            if ( input.states && input.states.map ) { // list [GenState]
                this.states = input.states.map( ( x: GenState ) => {
                    return new GenState( x );
                } );
            } else {
                this.states = input.states;
            }
       }
    }

    static jsonResponseToList(arr: any[]): GenEiaRegion[] {
        if (arr && arr.map) {
          return arr.map(a => new GenEiaRegion(a));
        } else {
          return [];
        }
    }
}

